import { useInfiniteQuery, useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { transactionEvmAbiMethodListKey, transactionListKey } from '~/api/service/query-keys.const'
import { TransactionAbiFunctionParamListModel, TransactionAbiMethodParamInfoModel, TransactionListModel } from '~/types/model/transaction.model'
import { type ITransactionParam } from '~/types/transaction.type'
import type { EvmABIFunctionParamRequest } from '../repository'

export const transactionService = {
  useGetTransactionList: (param: Ref<ITransactionParam>) => {
    const getTransactionScrollList = (pageParam?: number) => {
      return explorerApi.trxController.getTrxScrollList({
        requestBody: {
          size: param.value.size,
          lastVal: pageParam
        }
      })
    }
    return useInfiniteQuery([ ...transactionListKey, param ], async ({ pageParam = undefined }) => {
      const res = await getTransactionScrollList(pageParam)
      return new TransactionListModel(res as EvmTrxListInfo)
    }, {
      getNextPageParam: (lastPage: TransactionListModel) => {
        if (lastPage.transactionList.length < 100) {
          return undefined
        }
        return lastPage.transactionList.at(-1)?.sequenceNumber
      }
    })
  },
  useGetEvmAbiFunctionParamList: (params: EvmABIFunctionParamRequest) => {
    const getEvmAbiFunctionParamList = () => {
      return explorerApi.trxController.getEvmAbiFunctionParamList({
        requestBody: params
      })
    }

    return useQuery([...transactionEvmAbiMethodListKey, params], async () => {
      const res = await getEvmAbiFunctionParamList()
      return new TransactionAbiMethodParamInfoModel(res)
    })
  }
}